import React from "react";
import LocationFleetCms from "./LocationFleetCms";

const SpeedBoatCms = () => (
  <LocationFleetCms
    pageKey="SpeedBoat"
    heading="Speed Boats"
    intro="Manage speed boats for the Speed Boat page. Tick One Way and/or Two Way so the same boat can appear in both tabs."
    entityLabel="Speed Boat"
    locationALabel="One Way"
    locationBLabel="Two Way"
    fleetALabel="Mandwa / Alibaug"
    fleetBLabel="Elephanta"
  />
);

export default SpeedBoatCms;
